import React from 'react';
import { Input, Form } from 'antd';

// https://ant.design/components/form/#components-form-demo-basic
const FormTextField = ({
  label,
  name,
  rules,
  layout,
  help,
  extra,
  ...rest
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      layout={layout}
      help={help}
      extra={extra}
    >
      <Input {...rest} />
    </Form.Item>
  );
};

export default FormTextField;
